import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { SelectList } from "@common/selectList";
import { CalendarView, Props } from "./types";
import styles from "./styles.scss";

const views: { key: CalendarView; label: string }[] = [
  { key: "month", label: "calendarPage.monthlyView" },
  { key: "week", label: "calendarPage.weeklyView" },
  { key: "day", label: "calendarPage.dailyView" },
];

function DisplayToggle({ view, toggle }: Props) {
  const { t } = useTranslation();
  const current = views.find((v) => v.key === view)!;

  return (
    <SelectList<CalendarView> listClassName={styles.list}>
      {({ select }) => ({
        input: (
          <div className={styles.input}>
            <p className={styles.label}>{t(current.label)}</p>
            <svg
              className={styles.chevron}
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L5 5L9 1"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        ),
        list: (
          <ul className={styles.options}>
            {views.map((v) => (
              <li
                key={v.key}
                className={classNames(styles.option, {
                  [styles.selected]: view === v.key,
                })}
                onClick={() => toggle(select(v.key))}
              >
                <p>{t(v.label)}</p>
              </li>
            ))}
          </ul>
        ),
      })}
    </SelectList>
  );
}

export { DisplayToggle };
